import '../globals';

/**
 * Make header sticky
 */
(function(PageLoadedQueue) {
    window.PageLoadedQueue.addFunction(function() {
        const sticky = document.querySelector('.header--fixable');
        const dropdown = document.querySelector('.cart-preview .dropdown-menu');

        if (sticky && dropdown) {
            const stickyHeader = () => {
                const mediaBreakpointUpLg = window.checkViewport('min-width: 992px');
                const headerMeta = document.querySelector('.header-meta');

                if (mediaBreakpointUpLg && window.scrollY >= (headerMeta?.clientHeight ?? 35)) {
                    sticky.classList.add('is-fixed');
                } else {
                    sticky.classList.remove('is-fixed');
                }
            };

            stickyHeader();
            window.addEventListener('resize', stickyHeader, {passive: true});
            window.addEventListener('scroll', stickyHeader, {passive: true});
        }
    });
})(window.PageLoadedQueue);
